module.exports = __webpack_public_path__ + "img/shep.14d1cca9.jpg";